import React from 'react'
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import TableBody from '@mui/material/TableBody';
import Paper from '@mui/material/Paper';
import UiTableHead from '../../../../_uiComponents/UiTableHead';
import TablePagination from '@mui/material/TablePagination';
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import UiSwitch from '../../../../../_uiMocks/_uiComponents/UiSwitch';

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}


export default function MeasurementsTable(props) {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(8);
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState();


    const headings = [
        { id: 'name', name: 'Name' },
        { id: 'duration', name: 'Duration' },
        { id: '', name: '' },
        { id: '', name: '' }
    ]
    const rows = [
        {
            id: 1,
            name: 'New year offer products',
            duration: '2024-01-01 - 2025-01-01',
        },
        {
            id: 2,
            name: 'New year offer products',
            duration: '2024-01-01 - 2025-01-01',
        },
    ]
    //Sorting
    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    //Data sorting
    const sortingRows = React.useMemo(
        () =>
            stableSort(rows, getComparator(order, orderBy)).slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage,
            ),
        [order, orderBy, page, rowsPerPage, rows],
    );

    const handleChange = (event, index) => {
        // let newArr = [...newRows];
        // newArr[index].enable = event.target.checked;
        // setNewRows(newArr);
    };


    return (
        <>
            <div className='sba-table-main-wr'>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650, mt: 0 }} aria-label="simple table" className='sbt-data-grid'>
                        <UiTableHead
                            headings={headings}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort} />
                        <TableBody>
                            {sortingRows.map((row, index) => (
                                <>
                                    <TableRow>
                                        <TableCell>
                                            {row.name}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row.duration}
                                        </TableCell>
                                        <TableCell align="center">
                                            <UiSwitch
                                                checked={row.enable}
                                                handleChange={(event) => {
                                                    handleChange(event, index)
                                                }}
                                                name={row.name} />
                                        </TableCell>

                                        <TableCell align="right">
                                            <div className="sbt-data-grid__action-bar">
                                                <InfoIcon className='sba-grid-info-icon' />
                                                <Tooltip title="Preview" placement="top" arrow>
                                                    <IconButton aria-label="delete" sx={{ ml: 1.5 }}>
                                                        <VisibilityIcon />
                                                    </IconButton>
                                                </Tooltip>

                                                <Tooltip title="Edit" placement="top" arrow>
                                                    <IconButton aria-label="delete" sx={{ ml: 0.5 }}>
                                                        <EditIcon />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Delete" placement="top" arrow>
                                                    <IconButton aria-label="delete" sx={{ ml: 0.5 }}>
                                                        <DeleteIcon color="error" />
                                                    </IconButton>

                                                </Tooltip>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                </>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />



        </>
    )
}
